export var RelationshipStatus = /*#__PURE__*/ function(RelationshipStatus) {
    /** A proposal. */ RelationshipStatus["Pending"] = "pending";
    /** An approved agreement. */ RelationshipStatus["Approved"] = "approved";
    /** A canceled proposal. */ RelationshipStatus["Canceled"] = "canceled";
    /** An agreement that was terminated. */ RelationshipStatus["Terminated"] = "terminated";
    /** A proposal that has expired. */ RelationshipStatus["Expired"] = "expired";
    /** An ad-hoc invoicing relationship (no signed agreement). */ RelationshipStatus["AdHoc"] = "adHoc";
    return RelationshipStatus;
}({});
export var RelationshipProgressStatus = /*#__PURE__*/ function(RelationshipProgressStatus) {
    RelationshipProgressStatus["Sent"] = "sent";
    RelationshipProgressStatus["Reviewed"] = "reviewed";
    RelationshipProgressStatus["MicroDeposit"] = "microDeposit";
    RelationshipProgressStatus["PaymentMethod"] = "paymentMethod";
    RelationshipProgressStatus["Approved"] = "approved";
    RelationshipProgressStatus["MicroDepositFailed"] = "microDepositFailed";
    RelationshipProgressStatus["Expired"] = "expired";
    return RelationshipProgressStatus;
}({});
